<template>
  <input-custom v-bind:id="id"
                v-bind:errors="errors"
                v-bind:label="label"
                v-bind:language="language"
                v-bind:required="required"
                v-bind:loading="loading">
    <tree-branch v-bind:value="value"
                 v-bind:branch-style="branchStyle"
                 v-bind:branch-class="branchClass"/>
    <template v-if="help" v-slot:help="">
      <slot></slot>
    </template>
  </input-custom>
</template>

<script>
import TreeBranch from "../components/tree-branch";

export default {
  components: {
    TreeBranch
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Array
    },
    errors: {
      type: Array
    },
    label: {
      type: String
    },
    language: {
      type: String
    },
    required: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    branchStyle: {
      type: String
    },
    branchClass: {
      type: String
    },
  },
  computed: {
    help: function () {
      return !!this.$scopedSlots.default;
    },
  },
}
</script>
